module.exports = __webpack_public_path__ + "img/locate_a_charger.7ef63c0d.png";